import React from 'react'
import { Flex, Text } from '@workwhile/ui'

export const JurisdictionsEmptyState = () => (
  <Flex justifyContent="center" p={3}>
    <Text color="lightText">No jurisdictions attached.</Text>
  </Flex>
)
